function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SET_VISITING_VIA_URL = 'SET_VISITING_VIA_URL';
var SET_SEARCH_OPENED = 'SET_SEARCH_OPENED';
export var initialState = {
  routingDisabled: false,
  visitingViaUrl: true,
  searchOpened: false
};
export var dispatchVisitingViaUrl = function dispatchVisitingViaUrl(dispatch, payload) {
  return dispatch({
    type: SET_VISITING_VIA_URL,
    payload: payload
  });
};
export var dispatchSearchOpened = function dispatchSearchOpened(dispatch, payload) {
  return dispatch({
    type: SET_SEARCH_OPENED,
    payload: payload
  });
};
export var reducer = function reducer(state, action) {
  switch (action.type) {
    case SET_VISITING_VIA_URL:
      return _extends({}, state, {
        visitingViaUrl: action.payload
      });

    case SET_SEARCH_OPENED:
      return _extends({}, state, {
        searchOpened: action.payload
      });

    default:
      return state;
  }
};